import { createRoot } from 'react-dom/client';
import './index.less';
import App from './pages/root/App';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
